// Chakra imports
import {
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import TablesTableRow from "components/Tables/TablesTableRow";
import React from "react";

const Authors = ({ title, captions, filteredData }) => {
console.debug("filteredData", filteredData);
  const textColor = useColorModeValue("gray.700", "white");
  return (
    <Card b='white' overflowX={{ sm: "scroll", xl: "hidden" }} style ={{ background: 'white', minHeight: 348 }}>
      <CardHeader p='6px 0px 22px 0px'>
        <Text fontSize='xl' color={textColor} fontWeight='bold'>
          {title}
        </Text>
      </CardHeader>
      <CardBody>
        <Table variant='simple' color={textColor}>
          <Thead>
            <Tr my='.8rem' pl='0px' color='gray.400'>
              {captions.map((caption, idx) => {
                return (
                  <Th color='gray.400' key={idx} ps={idx === 0 ? "0px" : null}>
                    {caption}
                  </Th>
                );
              })}
            </Tr>
          </Thead>
          <Tbody>
            {filteredData.map((row) => {
              return (
                <TablesTableRow
                {...row }
                  key={`${row.id}-${row.name}`}
//                  name={row.name}
//                  logo={row.logo}
//                  email={row.email}
//                  subdomain={row.subdomain}
//                  domain={row.domain}
//                  status={row.status}
//                  date={row.date}
                />
              );
            })}
          </Tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default Authors;
